var WorkIndex = function () {
    var $window, $body, $pageHeader, $navigationContainer, $siteContent, $dummyNavigationContainer, $navigation, $subNavigation,
        $pageContent, $layoutParent, mason;
    var activeFiltersClass = 'filters-active';
    var activeSubFiltersClass = 'subfilters-active';
    var activeFilterClass = 'active';

    var wAreas = window.w_areas;

    var lastScrollTop = 0;
    var initScrollTop = 0;
    var scrollDir = 0;

    function init () {
        $window = $(window);
        $body = $('body');
        $pageContent = $body.find('.home-content');
        $pageHeader = $pageContent.find('.page-header');
        $navigationContainer = $('.logo-menu');
        $siteContent = $('.site-content .page-content');
        $navigation = $pageHeader.find('.work-navigation');
        $subNavigation = $pageHeader.find('.work-subnavigation');
        $layoutParent = $pageContent.children('.body');
        setNavigationState();
        setSubNavigationState();
        registerMediaQueries();
        registerEvents();
        // addRandomDelayClasses($layoutParent.children());
        setTimeout(enableHeaderTransition, 500);

        $window.on('scroll', fixNavigation);
        $window.trigger('scroll');
    }

    function getCategoryPath (index = 0) {
        var pathname = getPathnameOnly(window.location.href);
        var parts = pathname
            .replace(/^\/|\/$/, '')
            .split('/');
        var matches = pathname.match( new RegExp('/(' + wAreas.join('|') + ')/', 'gi') );
        if ( matches ) {
            return matches[0] + parts[index + 1];
        }
        if (parts[index]) {
            return '/' + parts[index];
        }
        return;
    }

    function fixNavigation () {
        var navigationContainerHeight = $navigationContainer.outerHeight();
        var siteContentTop = $siteContent[0].getBoundingClientRect().top;


        if (siteContentTop - navigationContainerHeight <= 0) {
            if (!$navigationContainer.hasClass('fixed')) {
                $navigationContainer.addClass('fixed');
                $navigationContainer.addClass('initialized');
            }
        }
        if (siteContentTop - navigationContainerHeight >= 0) {
            if ($navigationContainer.hasClass('fixed')) {
                $navigationContainer.removeClass('fixed');
            }
        }
    }

    function setHiddenNavigationHeight () {
        var height = $navigationContainer.outerHeight();
        $dummyNavigationContainer.css('height', `${height}px`);
    }

    function showHideNavigation () {
        var scrollY = window.pageYOffset;
        var dummyNavigationHeight = $navigationContainer.outerHeight();
        var newScrollDir = scrollY > lastScrollTop;
        lastScrollTop = scrollY;
        if (newScrollDir != scrollDir) {
            initScrollTop = scrollY;
            scrollDir = newScrollDir;
        }
        var delta = scrollY - initScrollTop;
        if (delta + dummyNavigationHeight > 0 && $navigationContainer.hasClass('fixed')) {
            $navigationContainer.addClass('stashed-away');
        }
        // Show again if top of the page or enough movement
        if (delta < -100 || scrollY < 200) {
            $navigationContainer.removeClass('stashed-away');
        }
    }

    function enableHeaderTransition () {
        // $pageHeader.css('transition-duration', '200ms');
        $pageHeader.addClass('enable-transition');
    }

    function getActiveCategory () {
        /*
        Checks if there is something else than /work in the url.
        Returns and object with:
            categoryHandle: '' for /work and 'vr' for /work/vr
            categoryElement: the corresponding element in the nav
            subCategoryHandle: '' for /work/animation and '2d' for /work/animation/2d
            subCategoryElement: the corresponding element in the nav
        */

        var pathname = window.location.pathname;
        var parts = pathname.replace(/^\/|\/$/, '').split('/');
        var categoryElement, categoryHandle, subCategoryElement, subCategoryHandle;
        if (parts) {
            if (parts[0]) {
                categoryHandle = parts[0];
            }
            if (parts[1]) {
                subCategoryHandle = parts[1];
            }
        } else {
            return null;
        }
        // Find the link that matches our pathname
        // The pathname can be:
        // - /work/category?
        // - /na/work/category?
        categoryElement = $navigation.find('a').toArray().map($).filter(function ($el) {
            var elPathname = getPathnameOnly($el.attr('href'));
            var category = getCategoryPath();
            return elPathname === category;
        })[0];

        // Find the link that matches our pathname
        // The pathname can be:
        // - /work/category/subcategory?
        // - /na/work/category/subcategory?
        $subNavigation = $pageHeader.find('.work-subnavigation');
        subCategoryElement = $subNavigation.find('a').toArray().map($).filter(function ($el) {
            var elPathname = getPathnameOnly($el.attr('href')).replace(getCategoryPath(), '');
            var subcategory = getCategoryPath(1);
            return elPathname === subcategory;
        })[0];

        return {
            categoryHandle: categoryHandle,
            categoryElement: categoryElement,
            subCategoryHandle: subCategoryHandle,
            subCategoryElement: subCategoryElement,
        };
    }

    function setNavigationState () {
        var activeCategory = getActiveCategory().categoryElement;
        if (!activeCategory) {
            $pageContent.removeClass(activeFiltersClass);
            $navigation.find('a').removeClass(activeFilterClass);
        } else {
            $pageContent.addClass(activeFiltersClass);
            $navigation.find('a').removeClass(activeFilterClass);
            activeCategory.addClass(activeFilterClass);
        }
    }

    function setSubNavigationState () {
        var activeSubCategory = getActiveCategory().subCategoryElement;
        if (!activeSubCategory) {
            $pageContent.removeClass(activeSubFiltersClass);
            $subNavigation.find('a').removeClass(activeFilterClass);
        } else {
            $pageContent.addClass(activeSubFiltersClass);
            $subNavigation.find('a').removeClass(activeFilterClass);
            activeSubCategory.addClass(activeFilterClass);
        }
    }

    function getPathnameOnly (url) {
        /*
        From a given url, match only the path, without host, query or hash
        https://www.google.co.uk/search?q=ibm+watson&oq=ibm+watson&aqs=chrome..69i57j0l5.5285j0j7&sourceid=chrome&ie=UTF-8
        -> /search
        */
        var re = new RegExp('^(?:https?:)?//.+?(/.*?)(?:/|/?[#?]+.*)?$');
        var matches = url.match(re);
        if (matches && matches.length > 1) return matches[1];
        return url;
    }

    function addRandomDelayClasses ($els) {
        var delays = [
            'delay-1',
            'delay-2',
            'delay-3',
            'delay-4',
        ];
        // Math.floor(Math.random()*myArray.length)
        $els.toArray().map($).forEach(function ($el) {
            $el.addClass(delays[Math.floor(Math.random()*delays.length)]);
        });
    }

    function hasCategoryChanged(currentPath, previousPath) {
        var currentPathnameCategory = currentPath.replace(/^\/|\/$/, '').split('/')[0];
        var previousPathnameCategory = previousPath.replace(/^\/|\/$/, '').split('/')[0];

        return currentPathnameCategory !== previousPathnameCategory;
    }

    function loadCategory (categoryURL, previousURL) {
        categoryURL = categoryURL.replace(new RegExp('/(' + wAreas.join('|') + ')/', 'gi'), '');
        var contentPath = categoryURL === '/' ? '/' : '/?pagename=' + categoryURL;
        var $oldDescription = $body.find('.home-content > .description');
        var $oldSubnavigation = $body.find('.home-content .work-subnavigation');
        var $oldBlocks = $layoutParent.children();
        addRandomDelayClasses($oldBlocks);
        var categoryHasChanged = hasCategoryChanged(categoryURL, previousURL);
        $oldBlocks.css({opacity: 0});
        $oldDescription.css({opacity: 0});

        if (categoryHasChanged) {
            $oldSubnavigation.css({opacity: 0});
        }

        $.get(contentPath, () => {
            $window.trigger('unloadContent');
        })
            .done(function(html) {
                var $html = $(html);
                var $newDescription = $html.find('.home-content > .description');
                var $newSubnavigation = $html.find('.home-content .work-subnavigation');
                var $newBlocks = $html.find('.page-content > .body').children();

                // Prepare
                $newBlocks.css({opacity: 0});
                $newDescription.css({opacity: 0});
                if (categoryHasChanged) {
                    $newSubnavigation.css({opacity: 0});
                }

                addRandomDelayClasses($newBlocks);

                // Append & replace
                $oldDescription.replaceWith($newDescription);
                if (categoryHasChanged) {
                    $oldSubnavigation.replaceWith($newSubnavigation);
                }
                setSubNavigationState();
                setHiddenNavigationHeight();

                requestAnimationFrame(function () {
                    $layoutParent.empty();
                    $layoutParent.append($newBlocks);

                    // Reveal
                    requestAnimationFrame(function () {
                        $newBlocks.css({opacity: 1});
                        $newDescription.css({opacity: 1});
                        if (categoryHasChanged) {
                            $newSubnavigation.css({opacity: 1});
                        }
                        $window.trigger('scroll');
                        $window.trigger('loadContent');

                        if (mason) {
                            // Layout
                            requestAnimationFrame(function () {
                                layout($layoutParent);
                                setTimeout(function () {
                                    // This is important
                                    mason.reloadItems();
                                    $(window).trigger('scroll');
                                }, 100);
                            });
                        }
                    });
                });
            })
            .fail(function() {
                $oldBlocks.css({opacity: 1});
                $oldDescription.css({opacity: 1});
                $oldSubnavigation.css({opacity: 1});
                return new Error('Error loading' . categoryURL);
            });
    }

    function layout ($layoutParent) {
        if (typeof Masonry === 'undefined') {
            let err = 'Missing Masonry. Aborting layout';
            return new Error(err);
        }
        var options = {
            transitionDuration: 0,
            columnWidth: '.half-width',
        };
        if($layoutParent.length) {
            mason = new Masonry($layoutParent[0], options);
        }
    }

    function registerEvents () {
        // Load category
        $body.on('click', '.work-navigation a', function(event) {
            event.preventDefault();
            var pathname = getPathnameOnly($(this).attr('href')).replace(/\/$/, '');
            var currentPathname = getPathnameOnly(window.location.href).replace(/\/$/, '');
            if (pathname === currentPathname) {
                /* Clear filters */
                pathname = '/';
            }
            history.pushState(null, '', pathname);
            loadCategory(pathname, currentPathname);
            setNavigationState();
        });
        $body.on('click', '.work-subnavigation a', function(event) {
            event.preventDefault();
            var pathname = getPathnameOnly($(this).attr('href')).replace(/\/$/, '');
            var currentPathname = getPathnameOnly(window.location.href).replace(/\/$/, '');
            if (pathname === currentPathname) {
                /* Clear subfilters */
                pathname = `${getCategoryPath()}`;
            }

            history.pushState(null, '', pathname);
            loadCategory(pathname, currentPathname);
            setNavigationState();
        });
        // Simple routing
        $window.on('popstate', function () {
            var pathname = getPathnameOnly(window.location.href);
            loadCategory(pathname);
            setNavigationState();
        });
        // $window.on('load', setHiddenNavigationHeight);
        // $window.on('resize', setHiddenNavigationHeight);
    }

    function registerMediaQueries () {
        enquire.register('screen and (min-width: 768px)', {
            match : function() {
                requestAnimationFrame(function () {
                    layout($layoutParent);
                });
                // $window.on('scroll.showHideNavigation', $.throttle(200, showHideNavigation));
            },
            unmatch : function() {
                if (typeof mason !== 'undefined') mason.destroy();
                $('section.body').attr('style','');
                // $window.off('scroll.showHideNavigation');
            }
        });
    }

    return {
        init: init
    }

}();
